<div class="dg-filter dg-filter--date">
  <button
    type="button"
    class="dg-filter_op"
    [class.dg-filter_op--active]="menuOpen"
    (click)="toggleMenu()"
    [attr.aria-label]="label(selectedOperator)"
    title="{{ label(selectedOperator) }}">
    <i class="fas fa-filter"></i>
  </button>

  <input
    class="dg-filter_input"
    [matDatepicker]="dp"
    [(ngModel)]="value"
    (dateChange)="apply()"
    placeholder="mm/dd/yyyy" />
    <mat-datepicker-toggle class="dg-filter_calendar" [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp></mat-datepicker>

    @if (value != null) {
      <button
        type="button"
        class="dg-filter_clear"
        (click)="clear()"
        aria-label="Clear">
        <i class="fas fa-times"></i>
      </button>
    }

    @if (menuOpen) {
      <ul class="dg-filter_menu">
        @for (op of operators; track op) {
          <li
            class="dg-filter_menu-item"
            [class.dg-filter_menu-item--selected]="op === selectedOperator"
            (click)="selectOperator(op)">
            {{ label(op) }}
          </li>
        }
      </ul>
    }
  </div>
